import { cloneDeep } from "lodash";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../redux/slices/treeSlice";
import { getUpdatedData } from "./NewRecordOutbound";
import { RECORD_TYPE, DATA_TYPE } from "../../../constants/datatypes";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { element } from "prop-types";
import { t } from "i18next";
import { genKey, getSelectedNodeWhileCreation, getUniqueWorkflowItemIdFromArray } from "../../../utils/utilFunctions";

const NewAction = ({ toggle, openModal }) => {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;
    const [showModal, setShowModal] = useState(false);
    const content = t('BOX_LIKE_TO_PLACE_ITEM_INSIDE_CURR_REC_OR_DIRECTLY_AFTER').split(`\\n`).map((str, idx) => <div key={idx}>{str ? str : <br />}</div>);
    const dispatch = useDispatch();
    const contentRef = useRef();
    const handleNewField = (isInside) => {
        const exactNode = getSelectedNodeWhileCreation(selectedNode, rightTree?.tree?.[currentTab]?.translatedData || [], isInside);
        let nestedLevels = exactNode.key.split("-");
        nestedLevels = nestedLevels.splice(1);
        const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);
        let initialId = translatedData?.[0]?.ID;
        const newId = getUniqueWorkflowItemIdFromArray(translatedData);

        // Function For Getting New Record Title and Key
        const getNewFieldData = (data, key) => {
            //If it is empty so it will make first node with 'ib-0' key
            if (!data.length) return { key: `${key}-0`, title: parentScreen === 'outbound' ? getNewAction(rightTree.tree) : getNewWorkflowAction(rightTree.tree), insertingPosition: 1 };

            let latestNewNodeNum = 0;
            let insertingPosition = 1;
            data.forEach((ele, idx) => {
                // Checking if Unnamed is present already for creating next unnamed record
                const fieldTitle = ele?.MAPNAME;
                if (fieldTitle && fieldTitle.startsWith(`${t("ACTION")}`)) {
                    const latestUnnamedRecord = Number(fieldTitle.slice(t("ACTION").length));

                    if (!isNaN(latestUnnamedRecord) && "ACTION_ITEM" === ele?.ICON_DISPLAY) {
                        latestNewNodeNum =
                            latestUnnamedRecord > latestNewNodeNum
                                ? latestUnnamedRecord
                                : latestNewNodeNum;
                    }
                }
                if (ele.key === selectedNode.key) {
                    insertingPosition = idx + 2;
                }
            });

            const lastRecordKey = data[data.length - 1].key.split("-");
            lastRecordKey[lastRecordKey.length - 1] = +lastRecordKey[lastRecordKey.length - 1] + 1;
            const newRecordKey = lastRecordKey.join("-");
            return {
                key: newRecordKey,
                title: parentScreen === 'outbound' ? getNewAction(rightTree.tree) : getNewWorkflowAction(rightTree.tree),
                insertingPosition,
            };
        };

        // Inserting New Node Object in Tree Data (Recursive Function);
        function insertNodeInNestedTree(translatedData, nestedLevels, isInside) {
            const level = isInside ? 0 : 1;
            if (nestedLevels.length === level) {
                const { children, key } = translatedData;
                const type = parentScreen === "workflow" ? "wf" : "ob";
                const newFieldDetails = children
                    ? getNewFieldData(children, key)
                    : getNewFieldData(translatedData, type);
                
                
                const newNode = {
                    nodeId:genKey(newFieldDetails.title),
                    alternateNodeId:genKey(newFieldDetails.title),
                    key: newFieldDetails.key,
                    title: parentScreen === 'outbound' ? `${t("_ACTION_")} ${newFieldDetails.title}` : `${newFieldDetails.title}`,
                    ICON_DISPLAY: "ACTION_ITEM",
                    NAME: newFieldDetails.title,
                    ...(parentScreen === "outbound" && {
                        TYPE: "ACTION",
                        OUTBOUND_ACTION_NAME: "",
                    }),
                    
                    ...(parentScreen === "workflow" && {
                        ACTION: "ACTION", 
                        ACTION_TYPE: "",
                        ID: newId + "", 
                        ENABLED: "TRUE", 
                        LOG_WFITEM_DETAILS: "TRUE",
                        CLEAR_ALL_ERRORS: "FALSE"  
                    }),
                };

                if (children) {
                    if (isInside) {
                        translatedData.children.splice(0, 0, newNode);
                        let newKey = selectedNode.key.split('-');
                        newKey.push('0')
                        newKey = newKey.join('-');
                        dispatch(treeActions.setRightTreeSelectedNode({
                            screen: parentScreen,
                            type: currentTab,
                            data: { ...newNode, key: newKey }
                        }));
                    } else {
                        const tempKey = selectedNode?.key?.split('-');
                        const lastIndex = + tempKey[tempKey.length-1] + 1

                        if(selectedNode?.ICON_DISPLAY === 'CONDITION_IF' && translatedData?.children[lastIndex]?.ICON_DISPLAY === "CONDITION_ELSE"){
                            translatedData.children.splice(lastIndex+1, 0, newNode);
                            let newKey = selectedNode.key.split('-');
                            newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 2;
                            newKey = newKey.join('-');
                            //  newNode.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                            dispatch(treeActions.setRightTreeSelectedNode({
                                screen: parentScreen,
                                type: currentTab,
                                data: { ...newNode, key: newKey }
                            }));
                        }
                        else{
                        translatedData.children.splice(newFieldDetails.insertingPosition - 1, 0, newNode);
                        let newKey = selectedNode.key.split('-');
                        newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 1;
                        newKey = newKey.join('-');
                        //  newNode.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                        dispatch(treeActions.setRightTreeSelectedNode({
                            screen: parentScreen,
                            type: currentTab,
                            data: { ...newNode, key: newKey }
                        }));
                    }
                }
                }
                return;
            }

            const isArray = Array.isArray(translatedData);
            if (isArray) {
                const nestedData = translatedData[[nestedLevels[0]]];
                const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(nestedData, newNestedLevels, isInside);
            } else {
                // const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(translatedData.children, nestedLevels, isInside);
            }
        }

        insertNodeInNestedTree(translatedData, nestedLevels, isInside);
        const updatedData = getUpdatedData(translatedData, templateHeader?.FILETYPE, null, parentScreen === 'workflow', currentTab);
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: currentTab,
                data: updatedData,
            })
        );
        toggle(null);
        setShowModal(false);
    };

    const newActionHandler = () => {
        if (selectedNode.key.split("-").length === 2 || selectedNode.ICON_DISPLAY === 'OBJECTS') {
            handleNewField(true);
            return;
        }
        else if (selectedNode.ICON_DISPLAY === "QUERY") {
            handleNewField(false)
            return;
        }
        else if (["CONDITION_IF", "CONDITION_ELSE", "LOOP_ITEM"].includes(selectedNode.ICON_DISPLAY) && openModal) {
            setShowModal(true);
        }
        else if (!RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal) {
            handleNewField(false);
            return;
        }
        else {
            setShowModal(true);
        }
    }
    useEffect(() => {
        if (openModal) {
            newActionHandler();
        }
    }, [openModal])

    return (
        <Dialog open={showModal} maxWidth="xs" fullWidth>
            <DialogTitle className="dialog-header">
                <div className="title">
                    {t("BOX_CONFIRM")}
                </div>
            </DialogTitle>
            <DialogContent className="dialog-content" dividers>
                <div>{content}</div>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant="outlined" color="primary" onClick={() => handleNewField(true)} >
                    {t("BTN_YES")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => handleNewField(false)} >
                    {t("BTN_NO")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => {
                    toggle(null);
                    setShowModal(false);
                }} >
                    {t("BTN_CANCEL")}
                </Button>
            </DialogActions>
        </Dialog>
    )
};


export default NewAction;

const getNewAction =(tree)=>{

    const data = cloneDeep(tree);
    const body = data.body.translatedData;
    const header = data.header.translatedData;
    const trailer = data.trailer.translatedData;
    let titleNumber = 0;
    let hasPlainAction = false; // Track if "Action: Action" exists without parentheses
  
    const getTitleName=(data)=>{
  
      data.forEach((ele,idx)=>{
        if(ele?.ICON_DISPLAY==="ACTION_ITEM" && ele?.NAME?.startsWith(`${t("ACTION")}`)){
          const title = ele.NAME;
          const openParenIndex = title.indexOf("(");
          const closeParenIndex = title.indexOf(")");
  
          if (openParenIndex > -1 && closeParenIndex > openParenIndex) {
            // Extract the number between parentheses
            const numberPart = title.slice(openParenIndex + 1, closeParenIndex).trim();
            const parsedNumber = parseInt(numberPart, 10);
  
            if (!isNaN(parsedNumber)) {
              titleNumber = Math.max(titleNumber, parsedNumber);
            }
          } else {
            // If "Action: Action" exists without parentheses
            hasPlainAction = true;
          }
        }
        if(ele?.children?.length>0){
          getTitleName(ele.children);
        }
      })
    }
  
    getTitleName(body);
    getTitleName(header);
    getTitleName(trailer);
    
    // If "Action: Action" exists without parentheses
    if (hasPlainAction && titleNumber === 0) {
      return `${t("ACTION")}(1)`;
    }
  
    return titleNumber === 0 ? `${t("ACTION")}` : `${t("ACTION")}(${titleNumber + 1})`;
  
  }

  const getNewWorkflowAction = (tree) => {
    const data = cloneDeep(tree);
    const body = data.body.translatedData;
    let titleNumber = 0;
    let hasPlainGetData = false; // Track if "Action" exists without parentheses
  
    const getTitleName = (data) => {
      data.forEach((ele) => {
        if (ele?.title?.startsWith(t("ACTION"))) {
          const title = ele.title;
          const openParenIndex = title.indexOf("(");
          const closeParenIndex = title.indexOf(")");
  
          if (openParenIndex > -1 && closeParenIndex > openParenIndex) {
            // Extract the number between parentheses
            const numberPart = title.slice(openParenIndex + 1, closeParenIndex).trim();
            const parsedNumber = parseInt(numberPart, 10);
  
            if (!isNaN(parsedNumber)) {
              titleNumber = Math.max(titleNumber, parsedNumber);
            }
          } else {
            // If "Action" exists without parentheses
            hasPlainGetData = true;
          }
        }
  
        if (ele?.children?.length > 0) {
          getTitleName(ele.children);
        }
      });
    };
  
    getTitleName(body);
  
    // If "Action" exists without parentheses
    if (hasPlainGetData && titleNumber === 0) {
      return `${t("ACTION")} (1)`;

    }
  
    return titleNumber === 0 ? `${t("ACTION")}` : `${t("ACTION")} (${titleNumber + 1})`;
  }
  